<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><g fill-rule="evenodd" clip-rule="evenodd"><path d="M16 6.834c6.201 0 11.465 3.804 13.334 9.083-1.87 5.28-7.133 9.084-13.334 9.084-6.2 0-11.464-3.804-13.333-9.084C4.536 10.637 9.799 6.834 16 6.834zm0 16.35c-5.211 0-9.603-3.049-11.384-7.267C6.397 11.7 10.789 8.651 16 8.651c5.212 0 9.603 3.048 11.385 7.266-1.782 4.218-6.173 7.267-11.385 7.267z"/><path d="M16 19a3.333 3.333 0 100-6.666A3.333 3.333 0 0016 19zm0 2a5.333 5.333 0 100-10.666A5.333 5.333 0 0016 21z"/></g></svg>
</template>

<script>
export default {
  name: 'symbolsEyeOutline'
}
</script>
